export type Permission = {
  id: string
  arName: string
  enName: string

  action: string
  object: string

  arDescription: string
  enDescription: string
}

export const PermissionGroupEndpoint = '/settings/permissions'
